import { canReadAny } from './roles';

export const RRHH_MANAGEMENT_RESOURCES = [
  'rrhh.plan-semanal', 'rrhh.jornales', 'rrhh.operaciones',
  'rrhh.dashboard', 'rrhh.reportes', 'rrhh.analisis', 'rrhh.configuracion',
  'rrhh.liquidacion', 'rrhh.remuneraciones', 'rrhh.liquidacion-parametros',
  'rrhh.liquidacion-cierre',
];

export const canAccessEmployeeModule = user => canReadAny(user, RRHH_MANAGEMENT_RESOURCES);
